/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from 'application/protocols';
import { AxiosHttpClientAdapter } from './axiosClientAdapter';

export const httpClient: HttpClient<any, any> = new AxiosHttpClientAdapter();
